// Small helper for the non-sensitive restaurant-selection values (id, name,
// logo, currency). These aren't secrets — the backend re-validates that the
// selected restaurant actually belongs to the logged-in user on every
// request regardless of what's stored here — this just keeps them out of
// localStorage for consistency with the rest of the session data.
export const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
};

export const setCookie = (name, value, days = 30) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
};
